import { ApiError } from './request'

/**
 * エラーが 401 Unauthorized かどうかを判定する。
 * XState の onError ガードで使用する。
 */
export const is401Error = (error: unknown): boolean => {
  return error instanceof ApiError && error.status === 401
}
